import { AxiosResponse } from 'axios';

import { get, post } from 'services/api';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `/procedures/emails/list?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const resend = (id: string): Promise<AxiosResponse> =>
  post(`/procedures/emails/${id}/resend`);

export const sendEmails = (): Promise<AxiosResponse> => get('/procedures/emails/send');
